// Tremor focusInput [v0.0.2]

export const focusInput = [
    // base
    "focus:ring-2",
    // ring color
    "focus:ring-blue-200 dark:focus:ring-blue-700/30",
    // border color
    "focus:border-blue-500 dark:focus:border-blue-700",
];
